"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _sourceTypes = _interopRequireDefault(require("./sourceTypes"));
var _targetTypes = _interopRequireDefault(require("./targetTypes"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _config = require("./config.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var fields = exports.fields = function () {
  var result = [];

  // Source types
  (0, _forEach2["default"])(_sourceTypes["default"], function (sourceType, name) {
    sourceType.fields.forEach(function (field) {
      result.push("sourceTypes.".concat(name, "[].").concat(field));
    });
  });

  // Target types
  (0, _forEach2["default"])(_targetTypes["default"], function (targetType, name) {
    targetType.fields.forEach(function (field) {
      result.push("targetTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description', 'allowCorrectAnswers', 'showCorrectStyle', 'showFeedback', 'feedbackPosition', 'feedbackTexts', 'mustDragAllItems', 'sources[].id', 'sources[].type', 'sources[].label', 'sources[].isExpanded', 'targets[].id', 'targets[].type', 'targets[].label', 'targets[].isExpanded', 'targets[].area', 'imageLayout', 'sourceArea', 'feedbackArea', 'isFeedbackExpanded', 'isSourcesExpanded', 'isTargetsExpanded', 'isImageLayoutExpanded'].concat(result);
}();
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings;
  var result = ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.sources.map(function (item, index) {
    return "sources[".concat(index, "].label");
  })));
  result.push.apply(result, _toConsumableArray(settings.targets.map(function (item, index) {
    return "targets[".concat(index, "].label");
  })));
  return result;
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  description: '',
  allowCorrectAnswers: false,
  showFeedback: false,
  showCorrectStyle: true,
  feedbackPosition: 'tooltip',
  feedbackTexts: {
    _fake_key: true // we need this key, because empty object is converted to an empty array on the backend
  },
  mustDragAllItems: false,
  sources: [{
    id: 1,
    label: 'Item 1',
    type: 'static'
  }, {
    id: 2,
    label: 'Item 2',
    type: 'static'
  }, {
    id: 3,
    label: 'Item 3',
    type: 'static'
  }],
  sourceTypes: {
    "static": [{
      id: 1
    }, {
      id: 2
    }, {
      id: 3
    }]
  },
  targets: [{
    id: 1,
    label: 'Target 1',
    type: 'static'
  }, {
    id: 2,
    label: 'Target 2',
    type: 'static'
  }],
  targetTypes: {
    "static": [{
      id: 1,
      showTargetLabel: true,
      allowUserItem: false,
      maxUserItems: 5,
      min: 0
    }, {
      id: 2,
      showTargetLabel: true,
      allowUserItem: false,
      maxUserItems: 5,
      min: 0
    }]
  },
  isSourcesExpanded: true,
  isTargetsExpanded: true
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-random"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  (0, _forEach2["default"])(_targetTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.targetTypes[type] || [], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      targetTypes: _objectSpread(_objectSpread({}, errors.targetTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  return errors;
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var enums = settings.targets.map(function (item) {
    return item.id;
  });
  var enumDisplayTexts = settings.targets.map(function (item) {
    return (0, _cccisdSurveyCommon.stripTags)(item.label);
  });
  var enumDisplayTextHtmls = settings.targets.map(function (item) {
    return (0, _cccisdWysiwyg.toHtml)(item.label);
  });
  var data = {};

  // dragged items
  settings.sources.forEach(function (source) {
    var code = "".concat(id, "_answer_").concat(source.id);
    data[code] = {
      variableType: 'quantitative',
      reportHeader: "dd_".concat(id, "_").concat(source.id),
      title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
      titleHtml: (0, _cccisdWysiwyg.toHtml)(settings.question),
      subtitle1: (0, _cccisdSurveyCommon.stripTags)(source.label),
      subtitle1Html: (0, _cccisdWysiwyg.toHtml)(source.label),
      "enum": enums,
      enumDisplayText: enumDisplayTexts,
      enumDisplayTextHtml: enumDisplayTextHtmls,
      questionType: 'Drag&Drop',
      tags: {
        system: ['answer']
      }
    };
  });

  // first 5 items in every target
  settings.targets.forEach(function (target) {
    [1, 2, 3, 4, 5].forEach(function (num) {
      var code = "".concat(id, "_target_").concat(target.id, "_").concat(num);
      var subtitle = "".concat((0, _cccisdSurveyCommon.stripTags)(target.label), ", Item ").concat(num);
      data[code] = {
        variableType: 'quantitative',
        reportHeader: "dd_".concat(code),
        title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
        titleHtml: (0, _cccisdWysiwyg.toHtml)(settings.question),
        subtitle1: subtitle,
        subtitle1Html: subtitle,
        questionType: 'Drag&Drop',
        tags: {
          system: ['answer']
        }
      };
    });
  });

  // Custom user text
  if (!settings.allowCorrectAnswers) {
    var targetsWithUserText = settings.targetTypes["static"].filter(function (item) {
      return item.allowUserItem;
    }).map(function (item) {
      return item.id;
    });
    settings.targets.filter(function (item) {
      return targetsWithUserText.includes(item.id);
    }).forEach(function (target) {
      for (var num = 1; num <= _config.MAX_USER_ITEMS; num++) {
        var code = "".concat(id, "_user_text_").concat(target.id, "_").concat(num);
        data[code] = {
          variableType: 'qualitative',
          reportHeader: "dd_".concat(code),
          title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
          titleHtml: (0, _cccisdWysiwyg.toHtml)(settings.question),
          subtitle1: (0, _cccisdSurveyCommon.stripTags)(target.label),
          subtitle1Html: (0, _cccisdWysiwyg.toHtml)(target.label),
          type: 'string',
          questionType: 'Drag&Drop',
          tags: {
            system: ['answer']
          }
        };
      }
    });
  }

  // Incorrect attempts
  if (settings.allowCorrectAnswers) {
    settings.sources.forEach(function (source) {
      var code = "".concat(id, "_incorrect_").concat(source.id);
      data[code] = {
        variableType: 'quantitative',
        reportHeader: "dd_".concat(code),
        title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
        titleHtml: (0, _cccisdWysiwyg.toHtml)(settings.question),
        subtitle1: (0, _cccisdSurveyCommon.stripTags)(source.label),
        subtitle1Html: (0, _cccisdWysiwyg.toHtml)(source.label),
        type: 'int',
        questionType: 'Drag&Drop',
        tags: {
          system: ['answer']
        }
      };
    });
  }
  return data;
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  var result = {};
  var targetIds = settings.targets.map(function (item) {
    return item.id;
  });
  var sourceLabels = settings.sources.reduce(function (obj, item) {
    obj[item.id] = (0, _cccisdSurveyCommon.stripTags)(item.label);
    return obj;
  }, {});

  // Sources
  settings.sources.forEach(function (source) {
    result["".concat(id, "_answer_").concat(source.id)] = null;
  });

  // Targets
  settings.targets.forEach(function (target) {
    [1, 2, 3, 4, 5].forEach(function (num) {
      result["".concat(id, "_target_").concat(target.id, "_").concat(num)] = null;
    });
  });
  if (settings.allowCorrectAnswers) {
    settings.sources.forEach(function (source) {
      result["".concat(id, "_incorrect_").concat(source.id)] = 0;
    });
  }

  // User texts
  if (!settings.allowCorrectAnswers) {
    var targetsWithUserText = settings.targetTypes["static"].filter(function (item) {
      return item.allowUserItem;
    }).map(function (item) {
      return item.id;
    });
    settings.targets.filter(function (item) {
      return targetsWithUserText.includes(item.id);
    }).forEach(function (target) {
      for (var num = 1; num <= _config.MAX_USER_ITEMS; num++) {
        result["".concat(id, "_user_text_").concat(target.id, "_").concat(num)] = null;
      }
    });
  }
  if (answer) {
    var _loop = function _loop() {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        targetId = _Object$entries$_i[0],
        items = _Object$entries$_i[1];
      if (!targetIds.includes(Number(targetId))) {
        return 1; // continue
      }
      var count = 1;
      items.forEach(function (item, index) {
        if (item.type === 'source' && "".concat(id, "_answer_").concat(item.id) in result) {
          result["".concat(id, "_answer_").concat(item.id)] = Number(targetId);
          result["".concat(id, "_target_").concat(targetId, "_").concat(index + 1)] = sourceLabels[item.id] || null;
        } else if (item.type === 'user' && "".concat(id, "_user_text_").concat(targetId, "_1") in result) {
          result["".concat(id, "_user_text_").concat(targetId, "_").concat(count++)] = item.label;
          result["".concat(id, "_target_").concat(targetId, "_").concat(index + 1)] = item.label;
        }
      });
    };
    for (var _i = 0, _Object$entries = Object.entries(answer.targets || {}); _i < _Object$entries.length; _i++) {
      if (_loop()) continue;
    }
    if (settings.allowCorrectAnswers) {
      for (var _i2 = 0, _Object$entries2 = Object.entries(answer.incorrect || {}); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          sourceId = _Object$entries2$_i[0],
          num = _Object$entries2$_i[1];
        if ("".concat(id, "_incorrect_").concat(sourceId) in result) {
          result["".concat(id, "_incorrect_").concat(sourceId)] = num;
        }
      }
    }
  }
  return result;
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var connectors = {};
  settings.targets.forEach(function (target, index) {
    var num = index + 1;
    connectors["target".concat(num, "Item1")] = {
      type: 'string',
      title: "First item of Target ".concat(num)
    };
    connectors["target".concat(num, "Item2")] = {
      type: 'string',
      title: "Second item of Target ".concat(num)
    };
    connectors["target".concat(num, "Item3")] = {
      type: 'string',
      title: "Third item of Target ".concat(num)
    };
    connectors["target".concat(num, "CommaText")] = {
      type: 'string',
      title: "Comma separated items from Target ".concat(num)
    };
    connectors["target".concat(num, "List")] = {
      type: 'string',
      title: "Items from Target ".concat(num, " as a list")
    };
    connectors["target".concat(num, "ItemNumber")] = {
      type: 'number',
      title: "Number of items in Target ".concat(num)
    };
  });
  return connectors;
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  var values = {};
  settings.targets.forEach(function (target, index) {
    var num = index + 1;
    var items = (0, _get2["default"])(answer, "targets[".concat(target.id, "]"), []).map(function (item) {
      return (0, _cccisdWysiwyg.toHtml)(item.label);
    });
    values["target".concat(num, "Item1")] = function () {
      return items[0] || '';
    };
    values["target".concat(num, "Item2")] = function () {
      return items[1] || '';
    };
    values["target".concat(num, "Item3")] = function () {
      return items[2] || '';
    };
    values["target".concat(num, "CommaText")] = function () {
      if (items.length <= 2) {
        return items.join(' and ');
      }
      return items.slice(0, items.length - 1).join(', ') + ', and ' + items[items.length - 1];
    };
    values["target".concat(num, "List")] = function () {
      if (items.length === 0) {
        return '';
      }
      return "<ul>".concat(items.map(function (item) {
        return "<li>".concat(item, "</li>");
      }).join(''), "</ul>");
    };
    values["target".concat(num, "ItemNumber")] = function () {
      return items.length;
    };
  });
  return values;
};